var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M24 19L12.995 8 2 19"}));
}

Arrow.defaultProps = {"viewBox":"0 0 26 26"};

module.exports = Arrow;

Arrow.default = Arrow;
